var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basket Shopping Orders"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6667 8.33331L15.4287 14.523C15.276 15.2866 15.1997 15.6684 15.0003 15.954C14.8245 16.2058 14.5825 16.4041 14.3011 16.5271C13.9819 16.6666 13.5926 16.6666 12.8138 16.6666H7.18614C6.40742 16.6666 6.01805 16.6666 5.69891 16.5271C5.41747 16.4041 5.1755 16.2058 4.9997 15.954C4.80034 15.6684 4.72398 15.2866 4.57126 14.523L3.33333 8.33331M16.6667 8.33331H15M16.6667 8.33331H17.5M3.33333 8.33331H2.5M3.33333 8.33331H5M15 8.33331H5M15 8.33331L12.5 3.33331M5 8.33331L7.5 3.33331M7.5 10.8333V13.3333M10 10.8333V13.3333M12.5 10.8333V13.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNote);
export default __webpack_public_path__ + "static/media/sidebar-note.9500edc5e4002ebdb9e9119673591bde.svg";
export { ForwardRef as ReactComponent };